export default __webpack_public_path__ + "static/media/factory-automation.5ea2f95a.jpeg";